var React = require('react'),
    TravelGuide = require('./components/guide'),
    DestinationGuide = require("./components/destination-guide"),
    CustomGuide = require("./components/custom-guide"),
    GuideFilter = require("./components/guide-filter");

window['GuideFilter'] = GuideFilter;

//TODO: clean up, this is clearly not a good way of determining what page we're on. 
if (document.getElementById('guide-container')){
  React.render(<TravelGuide />, document.getElementById('guide-container'));
} else if (document.querySelector('#destination-guide-container .dynamic-block')){
  React.render(<DestinationGuide />, document.querySelector('#destination-guide-container .dynamic-block'));
} else if (document.querySelector('#trip-container')){
  React.render(<CustomGuide isExpert={false} />, document.getElementById('trip-container'));
} else if (document.querySelector('#trip-idea-container')){
  React.render(<CustomGuide isExpert={true} />, document.getElementById('trip-idea-container'));
} else if (document.querySelector("#guide-starter")) {
  // React.render(<GuideFilter showDestinationSelector={ true } showDateSelector={ false } />, document.querySelector("#guide-starter"));
}


// WEBPACK FOOTER //
// ./main.js